import React from "react";
export const CrossOutTitleSelections = React.memo(function CrossOutTitleSelections({ originalSelections }) {
    return (React.createElement(React.Fragment, null, originalSelections ? (React.createElement(React.Fragment, null,
        React.createElement("span", { style: { textDecoration: "line-through", color: "gray" }, "data-testid": "cross-out-title-selections" }, originalSelections),
        "\u00A0")) : (React.createElement(React.Fragment, null))));
});
//# sourceMappingURL=CrossOutTitleSelections.js.map